
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"4","y":"2","width":"15","height":"24"}},[_c('path',{attrs:{"d":"M18.081 25.658l.41-.378a.606.606 0 000-.906L8.132 14.838s-.703-.554-.703-.908.703-.909.703-.909l10.36-9.536a.606.606 0 000-.907L18.08 2.2a.74.74 0 00-.985 0L4.848 13.476a.606.606 0 000 .907l12.248 11.275a.74.74 0 00.985 0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#14273C","d":"M25.073 26.929H4.643v-26h20.43z"}}),_c('path',{attrs:{"stroke":"#fff","d":"M24.573 26.429H5.143v-25h19.43z"}})])])
          )
        }
      }
    